import React from "react";

function Dentures() {
  return <div>Dentures</div>;
}

export default Dentures;
